// Checkbox
import { Field, FieldProps, useField } from "formik";
import React from "react";
import styles from "./Checkbox.module.sass";
import cn from "classnames";
import Icon from "../Icon";

interface CheckboxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string;
  formikFieldName: string;
  label: string;
  labelClassName?: string;
  isArray?: boolean;
  theme?: "light" | "dark";
}
const Checkbox: React.FC<CheckboxProps> = ({
  formikFieldName,
  id,
  label,
  labelClassName,
  isArray,
  theme,
  ...rest
}) => {
  const [field, _meta, helpers] = useField(formikFieldName);
  const fieldValue = field.value || {};
  const { setValue } = helpers;
  const isSelected = fieldValue[id] || false;
  const toggleSelect = () => {
    setValue({ ...fieldValue, [id]: !isSelected });
  };

  return (
    <label className={cn(styles.label, labelClassName)}>
      {isArray ? (
        <Field type="checkbox" name={formikFieldName} value={id}>
          {({ field, form }: FieldProps) => {
            const value = form.values[formikFieldName];
            const checked = value ? value.includes(id) : false;
            return (
              <>
                <input {...rest} {...field} type="checkbox" />
                <span
                  className={cn(styles.customCheck, {
                    [styles.dark]: theme === "dark",
                    [styles.light]: theme === "light",
                    [styles.checked]: checked,
                  })}
                >
                  {checked && <Icon name="check" />}
                </span>
              </>
            );
          }}
        </Field>
      ) : (
        <>
          <input {...rest} type="checkbox" onClick={toggleSelect} />
          <span
            className={cn(styles.customCheck, {
              [styles.dark]: theme === "dark",
              [styles.light]: theme === "light",
              [styles.checked]: isSelected,
            })}
          >
            {isSelected && <Icon name="check" />}
          </span>
        </>
      )}
      {label && (
        <p
          className={cn(styles.labelText, {
            [styles.light]: theme === "light",
          })}
        >
          {label}
        </p>
      )}
    </label>
  );
};

export default Checkbox;
